import {
  PASSPORT_HOST,
  getJSON,
  loadConverstData,
  encryption,
  getHrefParam,
  GMMOBILE_HOST,
  getHrefParamObj
} from "./ultile";
import { validateEmpty, loginValidate, registValidate } from "./validator";
const UPDATE_USER = "updateUserInfo";
export const GET_USER_INFO = "getUserInfo";
export const LOGIN = "login";
export const REGIST = "regist";
export const VERIFICATION_STATE = "verfificationState";
export const LOAD_QRCODE = "loadQrCode";
export const FB_LOGIN = "fbLogin";
export const GET_FB_INFO = "getFbInfo";
const UPDATE_FB_INFO = "updateFbInfo";
const GET_USER_INFO_ACTION = "ajax/h5_get_user_json";
const LOGIN_ACTION = "login/h5_login";
const REGIST_ACTION = "register/h5_register";
const NO_LOGIN = 0;
const HAVE_LOGINED = 1;
const RESET_STATE = "resetState";
const DETECT_SHOW_VERIFICATION_ACTION = "ajax/h5_ckcode_state";
const LOGIN_NEED_CKCODE = 1;
const REG_NEED_CKCODE = 1;
const UPDATE_CKCOE_LOGIN = "updataCKcodeLog";
const UPDATE_CKCOE_REGIST = "updateCKCodeReg";
const QRCODE_LOGIN_ACTION = "login/h5_qr_login";
const LOAD_QRCODE_ACTION = "ajax/h5_qrcode";
const FB_LOGIN_ACTION = "facebook/h5_direct_login_v2";
const GET_FB_USER_INFO_ACTION = "h5/fbPlay/getUserInfo";
let game_id = getHrefParam("gameid") || getHrefParam("game_id") || "";
let userMap = {
  id: "USER_ID",
  name: "LOGIN_ACCOUNT",
  avatar: "AVATAR",
  binding: "IS_BINDING",
  fbBinding: "BINDING_FB",
  lineBinding: "BINDING_LINE"
};

let emptyFBInfo = {
  avatart: "//www.gm99.com/images/noavatar.jpg",
  name: "",
  id: "",
  account: ""
};

export default {
  state: {
    user: loadConverstData({}, userMap),
    loginState: NO_LOGIN,
    loginCkcodeStatus: 0,
    registCkcodeStatus: 0,
    fbUserInfo: emptyFBInfo
  },
  mutations: {
    [UPDATE_USER](state, user) {
      state.user = user;
    },
    [RESET_STATE](state, account_status) {
      state.loginState = account_status;
    },
    [UPDATE_CKCOE_LOGIN](state, status) {
      state.loginCkcodeStatus = status;
    },
    [UPDATE_CKCOE_REGIST](state, status) {
      state.registCkcodeStatus = status;
    },
    [UPDATE_FB_INFO](state, { fb_user, gm_user }) {
      if (!fb_user) {
        state.fbUserInfo = emptyFBInfo;
      } else {
        state.fbUserInfo = {
          avatar: "//graph.facebook.com/" + fb_user.id,
          name: fb_user.name,
          id: fb_user.id,
          account: gm_user.LOGIN_ACCOUNT
        };
      }
    }
  },
  actions: {
    [VERIFICATION_STATE]({ commit }, userName) {
      let url = PASSPORT_HOST + DETECT_SHOW_VERIFICATION_ACTION;

      return new Promise((resolve, reject) => {
        getJSON(url, {
          uname: userName
        }).then(({ errmsg, data, res }) => {
          if (errmsg) {
            resolve(errmsg);
          }
          if (LOGIN_NEED_CKCODE == data.H5_LOGIN_NEED_CKCODE) {
            commit(UPDATE_CKCOE_LOGIN, true);
          } else {
            commit(UPDATE_CKCOE_LOGIN, false);
          }
          if (REG_NEED_CKCODE == data.H5_REG_NEED_CKCODE) {
            commit(UPDATE_CKCOE_REGIST, true);
          } else {
            commit(UPDATE_CKCOE_REGIST, false);
          }
          resolve(false);
        });
      });
    },
    [GET_USER_INFO]({ commit, dispatch }, { isCheck, ignore, loginType = "" }) {
      let url = PASSPORT_HOST + GET_USER_INFO_ACTION;
      let linkParam = getHrefParamObj();
      return new Promise((resolve, reject) => {
        getJSON(url, {
          h5_request: ignore ? 0 : 1,
          done_login: isCheck ? 0 : 1,
          login_type: loginType,
          ...linkParam
        }).then(({ errmsg, data, res }) => {
          let user = loadConverstData(data, userMap);
          if (errmsg) {
            commit(UPDATE_USER, user);
            commit(RESET_STATE, NO_LOGIN);

            dispatch("gaStatistics", {
              eventName: "login_un"
            });

            resolve({
              errmsg: errmsg,
              user: {}
            });
          } else {
            commit(UPDATE_USER, user);
            commit(RESET_STATE, HAVE_LOGINED);

            dispatch("setIsFirstPlay", data.FIRST_PLAY || false);
            if (isCheck) {
              dispatch("gaStatistics", {
                eventName: "login_success",
                data: {
                  login_type: "自动登录"
                }
              });
            }
            resolve({
              errmsg: "",
              user: user
            });
          }
        });
      });
    },
    /*
            @parameter account {
                uname
                password
                remember   是否记住密码
                forward    跳转链接
                ckcode     普通验证码	
                is_change  0:登陆，1:切换账号登陆
            }
        */
    [LOGIN]({}, account) {
      let url = (PASSPORT_HOST + LOGIN_ACTION).replace(
        /cid=(exe|url)/,
        "cid=484"
      );
      var validateResult = loginValidate(account, this.state.user);
      account.password = encryption(account.password);
      account.game_id = game_id;
      return new Promise((resolve, reject) => {
        var loginResult = true;
        loginResult = false;
        if (validateResult.dirty) {
          resolve({ loginResult, errmsg: validateResult.msg });
        }
        let linkParam = getHrefParamObj();
        getJSON(url, { ...account, ...linkParam }).then(
          ({ errmsg, data, res }) => {
            var loginResult = true;
            if (errmsg) {
              loginResult = false;
              resolve({ loginResult, errmsg });
            } else {
              errmsg = "";
              resolve({ loginResult, errmsg });
            }
          }
        );
      });
    },

    [REGIST]({}, account) {
      let url = (PASSPORT_HOST + REGIST_ACTION).replace(
        /cid=(exe|url)/,
        "cid=484"
      );
      var validateResult = registValidate(account);
      account.password = encryption(account.password);
      account.repassword = encryption(account.repassword);
      account.game_id = game_id;
      return new Promise((resolve, reject) => {
        let regestResult = true;
        let forward = "";
        if (validateResult.dirty) {
          regestResult = false;
          errmsg = validateResult.msg;
          resolve({ regestResult, errmsg, forward });
        }
        let linkParam = getHrefParamObj();
        getJSON(url, { ...account, ...linkParam }).then(
          ({ errmsg, data, res }) => {
            let regestResult = true;
            if (errmsg) {
              regestResult = false;
              resolve({ regestResult, errmsg, forward });
            } else {
              forward = res.forward;
              resolve({ regestResult, errmsg, forward });
            }
          }
        );
      });
    },
    [FB_LOGIN]({}, params) {
      return new Promise((resolve, reject) => {
        let linkParam = getHrefParamObj();
        getJSON(PASSPORT_HOST + FB_LOGIN_ACTION, {
          ...params,
          ...linkParam
        }).then(({ errmsg }) => {
          errmsg ? reject({ errmsg }) : resolve();
        });
      });
    },
    touristLogin({}, params) {
      return new Promise((resolve, reject) => {
        let linkParam = getHrefParamObj();
        getJSON(PASSPORT_HOST + "direct_login/h5_direct_login", {
          ...params,
          ...linkParam
        }).then(({ errmsg }) => {
          errmsg ? reject({ errmsg }) : resolve();
        });
      });
    },
    [GET_FB_INFO]({ commit }) {
      var location = GMMOBILE_HOST + GET_FB_USER_INFO_ACTION;
      var appID = getHrefParam("app_id");
      var auth_uid = getHrefParam("auth_uid");
      getJSON(location, {
        access_token: auth_uid,
        app_id: appID
      }).then(({ data, errmsg }) => {
        if (!errmsg) {
          commit(UPDATE_FB_INFO, data);
        } else {
          commit(UPDATE_FB_INFO, "");
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/user.js